import { Language } from "@/utils/language";
import { FiX } from "react-icons/fi";

interface LanguageBadgeProps {
  language: Language;
  level?: string;
  onRemove?: () => void;
  className?: string;
}

export function LanguageBadge({ language, level, onRemove, className = "" }: LanguageBadgeProps) {
  return (
    <div className={`flex flex-1 items-center bg-blue-50 p-2 rounded-md gap-2 ${className}`}>
      {onRemove && (
        <button onClick={onRemove} className="text-gray-500 hover:text-red-600 transition-colors">
          <FiX />
        </button>
      )}
      <span className="flex-1">{language.name}</span>
      <span className="text-lg">{language.flag}</span>
    </div>
  );
}
